<template>
  <v-card flat color="grey lighten-4">
    <v-card-text>
      <v-expand-transition>
        <v-row dense v-if="loading && !series">
          <v-col cols="12" class="text-center">
            <v-progress-circular indeterminate color="color3"></v-progress-circular>
          </v-col>
        </v-row>
      </v-expand-transition>
      <template v-if="series">
        <v-row dense v-if="series.iLeaderboard.leaders.length">
          <v-col cols="12" md="6" v-for="(board, i) in series.leaderboards" :key="i" :offset-md="series.leaderboards.length === 1 ? 3 : 0">
            <leaderboard
              :leaderboard="board"
              :byClub="series.settings.byClub"
              :byTeam="series.settings.byTeam"
              :loading="loading"
            ></leaderboard>
          </v-col>
        </v-row>
        <v-row dense v-else>
          <v-col cols="12" class="title my-12 text-center">
            You can't have leaders until the first event is played, silly 😉
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>

import Leaderboard from '@/components/Leaderboard/Leaderboard'
import Series from '@/classes/Series'
import { mapGetters } from 'vuex'

export default {
  props: ['active'],
  data () {
    return {
      series: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['tournament']),
    seriesTag () {
      return this.tournament.leaderboard
    },
    finishes () {
      return this.tournament.activeTeams.map(m => m.iFinish || m.finish)
    }
  },
  methods: {
    loadSeries () {
      this.loading = true
      this.$VBL.events.series.get(this.seriesTag)
        .then(r => {
          this.series = new Series(r.data)
        })
        .catch(e => console.log(e.response))
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.active && this.loadSeries()
  },
  watch: {
    active (v) {
      v && this.loadSeries()
    },
    finishes: 'loadSeries'
  },
  components: {
    Leaderboard
  }
}
</script>
